import {
  AnyTeamEntityVersion,
  Collections,
  FirestoreEntity,
  Mapper,
  Team,
} from '@uploadcam/common';
import invariant from 'tiny-invariant';
import { CollectionReference, doc, Firestore, getDoc } from 'firebase/firestore';
import { getCollectionRef } from '../../../../@harmony/angular';

export class GetTeamByIdInteractor {
  private readonly collection: CollectionReference<AnyTeamEntityVersion>;

  constructor(
    private readonly db: Firestore,
    private readonly mapper: Mapper<FirestoreEntity<AnyTeamEntityVersion>, Team>,
  ) {
    this.collection = getCollectionRef(this.db, Collections.Teams);
  }

  public async execute(id: string): Promise<Team> {
    const teamRef = doc(this.collection, id);
    const teamDoc = await getDoc(teamRef);
    const teamData = teamDoc.data();

    invariant(typeof teamData !== 'undefined', 'Empty Team data');

    return this.mapper.map(FirestoreEntity.from(teamDoc));
  }
}
